import o from "./isSymbol.js";
var i = o, f = 1 / 0;
function n(r) {
  if (typeof r == "string" || i(r))
    return r;
  var t = r + "";
  return t == "0" && 1 / r == -f ? "-0" : t;
}
var y = n;
export {
  y as default
};
//# sourceMappingURL=_toKey.js.map
